module.exports = __webpack_public_path__ + "static/v-cup-size-guide-db60ebb10911855eaabf46b3f830b873.png";